/**
 * 사업자등록번호 유효성 (형식 + 국세청 체크섬).
 * 형식만 맞는 랜덤 숫자를 걸러낸다. (휴폐업/진위는 국세청 API 필요 — 별도)
 */

/** 하이픈 등 제거 후 숫자만. */
export const normalizeBusinessNumber = (v: string): string =>
  (v ?? "").replace(/[^0-9]/g, "");

/**
 * 사업자등록번호 체크섬 검증.
 * 가중치 [1,3,7,1,3,7,1,3,5] 가중합 + floor(d[8]*5/10) → (10 - 합%10)%10 == d[9]
 */
export const isValidBusinessNumber = (v: string): boolean => {
  const d = normalizeBusinessNumber(v);
  if (d.length !== 10) return false;
  const weights = [1, 3, 7, 1, 3, 7, 1, 3, 5];
  let sum = 0;
  for (let i = 0; i < 9; i++) sum += Number(d[i]) * weights[i];
  sum += Math.floor((Number(d[8]) * 5) / 10);
  const check = (10 - (sum % 10)) % 10;
  return check === Number(d[9]);
};
